/**
 * Receptor
 * @author Thacryba
 */
import {$, Resource, ResponseSerialize} from 'simpli-web-sdk'
import {DocumentType} from '@/model/resource/DocumentType'

export class Receptor extends Resource {
  idReceptorPk: number = 0

  /**
   * Rut Receptor
   */
  document: string | null = null

  /**
   * Nombre o Razón social del Cliente receptor del documetno
   */
  name: string | null = null

  /**
   * Contacto receptor
   */
  email: string | null = null

  @ResponseSerialize(DocumentType)
  documentType: DocumentType | null = null

  telephone: string | null = null

  get $id() {
    return this.idReceptorPk
  }
  set $id(val) {
    this.idReceptorPk = val
  }
  get $tag() {
    return this.name != null
      ? String(this.name)
      : ($.t('app.notInformed') as string)
  }

  get idDocumentTypeFK() {
    if (!this.documentType) return 0
    return this.documentType.$id
  }
  set idDocumentTypeFK(val) {
    if (!this.documentType) this.documentType = new DocumentType()
    this.documentType.$id = val
  }
}
